import { render } from "./BaseDeleteDialog.vue?vue&type=template&id=36fc3f31"
import script from "./BaseDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BaseDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__